module.exports = "/static/media/documents_icon.0a1f9cb9.svg";